import { useState, useEffect } from "react";
import whatsappIcon from "../Assets/Images/whatsappIcon.webp";
import '../scss/FloatingWhatsapp.scss'


const WHATSAPP_LINK = "https://wa.me/923232920572";

const isMobileDevice = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  ) ||
  (typeof window !== "undefined" && window.innerWidth < 768);

const FloatingWhatsApp = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(isMobileDevice());
  }, []);

  return (
    <a
      href={WHATSAPP_LINK}
      {...(isMobile ? {} : { target: "_blank", rel: "noopener noreferrer" })}
      className="floating-whatsapp"
      aria-label="Chat on WhatsApp"
    >
      <img
        src={whatsappIcon}
        alt="WhatsApp"
        className="floating-whatsapp__img"
      />
    </a>
  );
};

export default FloatingWhatsApp;
